import { render, staticRenderFns } from "./numericClean.vue?vue&type=template&id=36693a6a&"
import script from "./numericClean.vue?vue&type=script&lang=js&"
export * from "./numericClean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QField,QInput})
